import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import PhoneIcon from '@mui/icons-material/Phone';
import { translate } from '@openclassrooms/translations';
import Tag from '@classify/react-core-components/Tag';
import Typography from '@classify/react-core-components/Typography';
import Button from '@classify/react-core-components/Button';
import { useLocalisationConfig } from '@openclassrooms/localisation/LocalisationConfigProvider';
import Stack from '@classify/react-core-components/Stack';
import Hyperlink from '@classify/react-core-components/Hyperlink';
type Hour = {
  hour: number;
  minute: number;
};
const isDayActive = (schedule: string, date: Date = new Date()): boolean => {
  const activeDays = new Set<number>();
  const parts = schedule.split(',');
  parts.forEach(part => {
    if (part.includes('-')) {
      const [start, end] = part.split('-').map(Number);
      for (let i = start; i <= end; i += 1) {
        activeDays.add(i);
      }
    } else {
      const day = Number(part);
      if (!isNaN(day)) {
        activeDays.add(day);
      }
    }
  });
  let currentDay = date.getDay();
  if (currentDay === 0) {
    currentDay = 7; // Convert Sunday from 0 to 7
  }
  return activeDays.has(currentDay);
};
function isOfficeOpen(openingDays: string, openingTime: Hour, closingTime: Hour, timeZone: string): boolean {
  if (!isDayActive(openingDays)) {
    return false;
  }

  // office hours to total minutes from midnight
  const openingTimeInMinutes = openingTime.hour * 60 + openingTime.minute;
  const closingTimeInMinutes = closingTime.hour * 60 + closingTime.minute;

  // get the current time in the timezone
  const now = new Date();
  const options: Intl.DateTimeFormatOptions = {
    timeZone,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  };

  // get current hour and minute in the timezone as strings
  const formatter = new Intl.DateTimeFormat(undefined, options);
  const parts = formatter.formatToParts(now);
  const currentHour = Number(parts.find(p => p.type === 'hour')?.value ?? 0);
  const currentMinute = Number(parts.find(p => p.type === 'minute')?.value ?? 0);

  // convert current time to total minutes from midnight
  const currentTimeInMinutes = currentHour * 60 + currentMinute;
  return currentTimeInMinutes >= openingTimeInMinutes && currentTimeInMinutes < closingTimeInMinutes;
}
export function formatTimeWithClock(timeString: string, hoursFormat24: boolean): string {
  const [hours, minutes] = timeString.split(':').map(Number);
  const date = new Date();
  date.setHours(hours, minutes, 0, 0);
  const options: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: 'numeric',
    hour12: !hoursFormat24
  };
  return new Intl.DateTimeFormat(undefined, options).format(date);
}
export default function PagePhone(t0) {
  const $ = _c(42);
  const {
    onGoBack
  } = t0;
  const [isOpen, setIsOpen] = useState(undefined);
  const {
    getLocalisationConfig
  } = useLocalisationConfig();
  let t1;
  if ($[0] !== getLocalisationConfig) {
    t1 = getLocalisationConfig("hoursFormat24");
    $[0] = getLocalisationConfig;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const is24HoursFormat = Boolean(t1);
  let t2;
  if ($[2] !== getLocalisationConfig) {
    t2 = getLocalisationConfig("contact.phone.number");
    $[2] = getLocalisationConfig;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const phoneNumber = String(t2);
  let t3;
  if ($[4] !== getLocalisationConfig) {
    t3 = getLocalisationConfig("contact.phone.officeHours");
    $[4] = getLocalisationConfig;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const [openingDays, openingTime, closingTime, timeZone] = String(t3).split("|");
  let updateIsOpen = _temp;
  if (openingTime && closingTime && timeZone) {
    const [openingHour, openingMinute] = openingTime.split(":").map(Number);
    const [closingHour, closingMinute] = closingTime.split(":").map(Number);
    updateIsOpen = () => isOfficeOpen(openingDays, {
      hour: openingHour,
      minute: openingMinute
    }, {
      hour: closingHour,
      minute: closingMinute
    }, timeZone);
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  useEffect(() => {
    setIsOpen(updateIsOpen());
    const interval = setInterval(() => {
      setIsOpen(updateIsOpen());
    }, 60000);
    return () => clearInterval(interval);
  }, t4);
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Typography variant="h5" component="h1" sx={{
      mb: 2
    }}>{translate("support.global.contact_channel.call.title")}{" "}</Typography>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const T0 = Stack;
  const t6 = 4;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Typography>{translate("support.global.contact_channel.call.subheading")}</Typography>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const T1 = Stack;
  const t8 = "row";
  const t9 = 2;
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <PhoneIcon />;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const T2 = Stack;
  const t11 = "column";
  const t12 = 1;
  let t13;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      borderLeft: "1px solid black",
      borderLeftColor: "layout.line.divider",
      pl: 2
    };
    $[10] = t13;
  } else {
    t13 = $[10];
  }
  const t14 = `tel:${phoneNumber}`;
  let t15;
  if ($[11] !== phoneNumber || $[12] !== t14) {
    t15 = <Hyperlink href={t14}>{phoneNumber}</Hyperlink>;
    $[11] = phoneNumber;
    $[12] = t14;
    $[13] = t15;
  } else {
    t15 = $[13];
  }
  let t16;
  if ($[14] !== isOpen) {
    t16 = isOpen === true ? <Tag color="success" size="small" sx={{
      ml: 1
    }}>{translate("support.global.contact_channel.call.open_status")}</Tag> : null;
    $[14] = isOpen;
    $[15] = t16;
  } else {
    t16 = $[15];
  }
  let t17;
  if ($[16] !== t15 || $[17] !== t16) {
    t17 = <div>{t15}{t16}</div>;
    $[16] = t15;
    $[17] = t16;
    $[18] = t17;
  } else {
    t17 = $[18];
  }
  const T3 = Typography;
  const t18 = translate("support.global.contact_channel.call.opening_times.all", {
    opening_time: formatTimeWithClock(openingTime, is24HoursFormat),
    closing_time: formatTimeWithClock(closingTime, is24HoursFormat),
    timezone: timeZone
  });
  let t19;
  if ($[19] !== T3 || $[20] !== t18) {
    t19 = <T3>{t18}</T3>;
    $[19] = T3;
    $[20] = t18;
    $[21] = t19;
  } else {
    t19 = $[21];
  }
  let t20;
  if ($[22] !== T2 || $[23] !== t13 || $[24] !== t17 || $[25] !== t19) {
    t20 = <T2 flexDirection={t11} gap={t12} sx={t13}>{t17}{t19}</T2>;
    $[22] = T2;
    $[23] = t13;
    $[24] = t17;
    $[25] = t19;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  let t21;
  if ($[27] !== T1 || $[28] !== t10 || $[29] !== t20) {
    t21 = <T1 flexDirection={t8} gap={t9}>{t10}{t20}</T1>;
    $[27] = T1;
    $[28] = t10;
    $[29] = t20;
    $[30] = t21;
  } else {
    t21 = $[30];
  }
  let t22;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = translate("global.word.back");
    $[31] = t22;
  } else {
    t22 = $[31];
  }
  let t23;
  if ($[32] !== onGoBack) {
    t23 = <div><Button onClick={onGoBack} variant="secondary">{t22}</Button></div>;
    $[32] = onGoBack;
    $[33] = t23;
  } else {
    t23 = $[33];
  }
  let t24;
  if ($[34] !== T0 || $[35] !== t21 || $[36] !== t23 || $[37] !== t7) {
    t24 = <T0 spacing={t6}>{t7}{t21}{t23}</T0>;
    $[34] = T0;
    $[35] = t21;
    $[36] = t23;
    $[37] = t7;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  let t25;
  if ($[39] !== t24 || $[40] !== t5) {
    t25 = <>{t5}{t24}</>;
    $[39] = t24;
    $[40] = t5;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  return t25;
}
function _temp() {}